import { MenuToggler } from "./app/menu.js"
import "./app/header.js"
import "./app/slider.js"

document.addEventListener("DOMContentLoaded", function () {
	new MenuToggler("#mega-menu-container", ".mega-menu-toggle")
})
